export default {
  page: '/',
  loggedIn: false,
  userType: null,
  darkMode: true,
  scrolled: false,
  sidebarOpen: true,
  activeCaseId: null,
  activeClientId: null,
  activeInvoiceId: null,
  selectedSlot: null,
  selectedTemplate: 'demand',
  generatingDoc: false,
  docOutput: null,
  analysisOutput: null,
  researchMessages: [],
  researchInput: '',
  activeTab: 'all',
  aiTab: 'draft',
  settingsTab: 'profile',
  alertDismissed: false,
  activeLangMenu: false,
  lawyers: [],
  lawyersLoaded: false,
  totalLawyers: 0,
  totalFirms: 0,
  lawyersVisible: 24,
  firms: [],
  firmsLoaded: false,
  directoryFilter: '',
  directoryView: 'all',
  areaFilter: '',
  cityFilter: '',
  verificationFilter: '',
  statusFilter: '',
  chatMessages: [],
  chatInput: '',
  chatTyping: false,
  _chatLastArea: null,
  publicBookingStep: 'select',
  showNewBooking: false,
  selectedBookingId: null,
  loginTab: 'lawyer',
  clientDashboardTab: 'cases',
  firm: {
    name: 'სამართლებრივი ჯგუფი "ბარათელი"',
    lawyer: 'ნინო ბარათელი',
    initials: 'ნბ',
    publicBookingUrl: 'legalos.ge/book/barateli',
  },
  stats: {
    openCases: 14,
    todayBookings: 3,
    unpaidInvoices: '₾1,840',
    overdueDeadlines: 2,
    aiUsageThisMonth: 23,
  },
  bookings: [
    { id: 1, client: 'გიორგი მამულაშვილი', time: '10:00', type: 'სამოქალაქო', status: 'confirmed', phone: '599123456' },
    { id: 2, client: 'მარიამ კვარაცხელია', time: '11:30', type: 'ადმინისტრაციული', status: 'pending', phone: '577234567' },
    { id: 3, client: 'დავით ჩიქოვანი', time: '14:00', type: 'სისხლის სამართალი', status: 'confirmed', phone: '598345678' },
  ],
  cases: [
    { id: 1, num: '#2024-047', client: 'გიორგი მამულაშვილი', type: 'სამოქალაქო', status: 'active', nextDeadline: '20 მარ', deadlineUrgent: true, updated: '18 მარ' },
    { id: 2, num: '#2024-046', client: 'მარიამ კვარაცხელია', type: 'ადმინისტრაციული', status: 'pending', nextDeadline: '25 მარ', deadlineUrgent: false, updated: '17 მარ' },
    { id: 3, num: '#2024-045', client: 'ლელა გოგიაშვილი', type: 'სისხლის სამართალი', status: 'court', nextDeadline: '19 მარ', deadlineUrgent: true, updated: '15 მარ' },
    { id: 4, num: '#2024-044', client: 'ზურაბ კობახიძე', type: 'სამოქალაქო', status: 'closed', nextDeadline: null, deadlineUrgent: false, updated: '10 მარ' },
  ],
  clients: [
    { id: 1, name: 'გიორგი მამულაშვილი', phone: '599123456', email: 'g.mamulasvili@gmail.com', activeCases: 1, totalBilled: '₾2,400', lastContact: '18 მარ' },
    { id: 2, name: 'მარიამ კვარაცხელია', phone: '577234567', email: 'mari.k@mail.ru', activeCases: 1, totalBilled: '₾800', lastContact: '17 მარ' },
    { id: 3, name: 'ლელა გოგიაშვილი', phone: '571456789', email: 'lela.g@inbox.ge', activeCases: 0, totalBilled: '₾1,800', lastContact: '15 მარ' },
    { id: 4, name: 'ზურაბ კობახიძე', phone: '593567890', email: 'zurab.k@gmail.com', activeCases: 0, totalBilled: '₾950', lastContact: '10 მარ' },
  ],
  invoices: [
    { id: 1, num: 'INV-2024-031', client: 'გიორგი მამულაშვილი', caseNum: '#2024-047', amount: '₾1,200', status: 'unpaid', due: '25 მარ' },
    { id: 2, num: 'INV-2024-030', client: 'მარიამ კვარაცხელია', caseNum: '#2024-046', amount: '₾640', status: 'paid', due: '15 მარ' },
    { id: 3, num: 'INV-2024-029', client: 'ლელა გოგიაშვილი', caseNum: '#2024-045', amount: '₾1,800', status: 'overdue', due: '10 მარ' },
  ],
  documents: [
    { id: 1, name: 'სარჩელი - მამულაშვილი.pdf', type: 'სარჩელი', caseNum: '#2024-047', date: '15 მარ' },
    { id: 2, name: 'მინდობილობა - კვარაცხელია.pdf', type: 'მინდობილობა', caseNum: '#2024-046', date: '12 მარ' },
  ],
  teamMembers: [
    { id: 1, name: 'ნინო ბარათელი', role: 'მფლობელი', email: 'nino@barateli.ge', active: true },
    { id: 2, name: 'გიგა ასლანიშვილი', role: 'ადვოკატი', email: 'giga@barateli.ge', active: true },
  ],
  clientPortal: {
    clientName: 'გიორგი',
    cases: [
      { num: '#2024-047', type: 'სამოქალაქო', status: 'active', progress: 3, totalSteps: 5, nextStep: 'სასამართლო სხდომა 25 მარტს', lastUpdate: '18 მარ' },
    ],
    invoices: [
      { num: 'INV-2024-031', amount: '₾1,200', due: '25 მარ', status: 'unpaid' },
    ],
    messages: [
      { from: 'lawyer', text: 'გამარჯობა გიორგი, საქმეზე ახალი განახლება გვაქვს.', time: '10:30' },
      { from: 'client', text: 'მადლობა, ველოდები დეტალებს.', time: '10:45' },
    ],
  },
}
